<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap pa-3>
          <v-flex lg3 md3 sm12>
            <v-text-field :readonly="isBillContentLocked" label="Mã phiếu xuất" v-model="currentItem.BillCode" class="input-group--focused" outlined dense></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-autocomplete :readonly="isBillContentLocked" label="Khách hàng" v-model="currentItem.UID" :items="customers" item-text="Username" item-value="ID" @change="onCustomerChanged" outlined dense></v-autocomplete>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-select
              :readonly="!canEditBillStatus"
              :disabled="!canEditBillStatus"
              label="Trạng thái phiếu xuất"
              v-model="currentItem.Status"
              :items="billStatusOptions"
              item-text="name"
              item-value="value"
              outlined
              dense
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              readonly
              label="Yêu cầu xuất kho liên kết"
              :value="selectedRequestCodes"
              outlined
              dense
            ></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker readonly plabel="Ngày xuất" class="input-group--focused date-picker" v-model="exportDate" @onChangeDate="exportDate = $event"></mh-date-picker> 
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input label="Tỷ giá" v-model="currentItem.ExchangeRate" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex>

          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng bill" v-model="currentItem.NumberOfCode" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng kiện" v-model="currentItem.NumberOfPack" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng cân" v-model="currentItem.Weight" :decimal="1" class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng khối" v-model="currentItem.Volume" :decimal="2" class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Tổng tiền" v-model="currentItem.AmountVND" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input readonly label="Thành tiền" v-model="currentItem.LineAmount" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input label="Đã thanh toán" v-model="currentItem.PaidAmount" :decimal="0" class="input-group--focused"></h-currency-input>
          </v-flex>
          
        </v-layout>
      </v-card>
    </v-container>
    <v-container grid-list-xl fluid pt-6>
      <v-card>
        <v-layout row wrap pa-3>
          <v-flex lg12 md12 sm12>
            <v-layout row wrap justify-end pr-1>
              <v-btn
                class="mx-2"
                dark
                small
                color="primary"
                @click="openRequestDialog"
                :disabled="isBillContentLocked"
                v-if="canEditBillContent"
              >
                <v-icon dark left small>assignment</v-icon>Yêu cầu xuất
              </v-btn>
              <v-btn
                class="mx-2"
                dark
                small
                color="red"
                @click="addDetail"
                :disabled="isBillContentLocked"
                v-if="canEditBillContent"
                ><v-icon dark>add</v-icon></v-btn
              >
            </v-layout>
          </v-flex>
          <v-flex lg12>
            <v-data-table :headers="detail_header" :items="details" disable-pagination hide-default-footer>
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.CustomerName || item.UserName }}</td>
                  <td>{{ item.PartnerName }}</td>
                  <td>{{ item.ProductNameCN }}</td>
                  <td>{{ item.Code }}</td>
                  <td>{{ item.SuffixBill }}</td>
                  <td class="text-right" v-if="canEditBillContent">
                    <v-edit-dialog :return-value.sync="item.Weight" large lazy @save="saveBillProduct({'BillID': itemId, 'ProductID': item.ID, 'Weight': item.Weight})">
                        <div>{{ item.Weight | currency('', 1) }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.Weight | currency("", 1) }}</td>
                  <td class="text-right" v-if="canEditBillContent">
                    <v-edit-dialog :return-value.sync="item.Volume" large lazy @save="saveBillProduct({'BillID': itemId, 'ProductID': item.ID, 'Volume': item.Volume})">
                        <div>{{ item.Volume | currency('', 2) }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.Volume" type="number" step=".01" label="Thể tích" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.Volume | currency("", 2) }}</td>
                  <td class="text-right" v-if="canEditBillContent">
                    <v-edit-dialog :return-value.sync="item.NumberOfPack" large lazy @save="saveBillProduct({'BillID': itemId, 'ProductID': item.ID, 'NumberOfPack': item.NumberOfPack})">
                        <div>{{ item.NumberOfPack | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.NumberOfPack" type="number" step="1" label="Số kiện hàng" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.NumberOfPack | currency }}</td>
                  <td class="text-right">{{ item.Deposit | currency("", 2) }}</td>
                  <td class="text-center"><v-icon medium :color="item.IsSplitTax ? 'red' : 'gray'">circle</v-icon></td>
                  <td class="text-right">{{ item.ImportTaxAmount | currency }}</td>
                  <td class="text-right">{{ item.VatTaxAmount | currency }}</td>
                  <td class="text-right">{{ item.ServiceFeeAmount | currency }}</td>
                  <td class="text-right" v-if="canEditBillContent">
                    <v-edit-dialog :return-value.sync="item.FeeShipVND" large lazy @save="saveBillProduct({'BillID': itemId, 'ProductID': item.ID, 'FeeShipVND': item.FeeShipVND})">
                        <div>{{ item.FeeShipVND | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.FeeShipVND" type="number" step="1" label="Phí ship" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.FeeShipVND | currency }}</td>
                  <td class="text-right">{{ item.Amount | currency }}</td>
                  <td class="text-right" v-if="canEditBillContent">
                    <v-edit-dialog :return-value.sync="item.DiscountAmount" large lazy @save="saveBillProduct({'BillID': itemId, 'ProductID': item.ID, 'DiscountAmount': item.DiscountAmount})">
                        <div>{{ item.DiscountAmount | currency }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.DiscountAmount" type="number" step="1" label="Chiết khấu" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-right" v-else>{{ item.DiscountAmount | currency }}</td>
                  <td class="text-right">{{ item.LineAmount | currency }}</td>
                  <td v-if="canEditBillContent">
                    <v-edit-dialog :return-value.sync="item.Note" large lazy @save="saveBillProduct({'BillID': itemId, 'ProductID': item.ID, 'Note': item.Note})">
                        <div>{{ item.Note }}</div>
                        <template v-slot:input>
                          <v-text-field v-model="item.Note" label="Ghi chú" single-line autofocus></v-text-field>
                        </template>
                    </v-edit-dialog>
                  </td>
                  <td v-else>{{ item.Note }}</td>
                  <td class="text-center">
                    <table-action-buttons :actions="getBillDetailActions(item)" :stacked="false"></table-action-buttons>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogItem" max-width="1300px">
      <v-card>
        <v-card-title>
          <span class="title">Danh sách hàng hóa</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogItem = false"
            >Đóng</v-btn
          >
          <v-btn @click="onSelectDetail"
            >Lưu lại</v-btn
          >
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <hpo-filter
                  :headers="popup_header"
                  :viewName="popupViewName"
                  v-on:applyFilter="applyFilterDetail"
                  v-on:quickFilter="quickFilterDetail"
                ></hpo-filter>
                <v-data-table
                  fixed-header
                  height="450px"
                  :headers="popup_header"
                  :items="popup_items"
                  item-key="ID"
                  disable-pagination
                  hide-default-footer
                  show-select
                  v-model="selectedDetail"
                >
                  <template v-slot:item="{ item, isSelected, select }">
                    <tr :active="isSelected" @click="select(!isSelected)">
                      <td><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                      <td>{{ item.CustomerName || item.UserName }}</td>
                      <td>{{ item.PartnerName }}</td>
                      <td>{{ item.ProductNameCN }}</td>
                      <td>{{ item.Code }}</td>
                      <td>{{ item.SuffixBill }}</td>
                      <td class="text-right">{{ item.Deposit | currency("", 2) }}</td>
                      <td class="text-right">{{ item.Weight | currency("", 1) }}</td>
                      <td class="text-right">{{ item.Volume | currency("", 2) }}</td>
                      <td class="text-right">{{ ((item.NumberOfPackImport | 0)-(item.NumberOfPackExport | 0)) | currency }}</td>
                      <td class="text-center"><v-icon medium :color="item.IsSplitTax ? 'red' : 'gray'">circle</v-icon></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRequest" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="title">Chọn yêu cầu xuất kho</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogRequest = false">Đóng</v-btn>
          <v-btn color="primary" @click="onSelectRequests">Nạp vào phiếu xuất</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-data-table
            :headers="requestHeaders"
            :items="availableRequests"
            item-key="ID"
            show-select
            disable-pagination
            hide-default-footer
            v-model="selectedRequestRows"
          >
            <template v-slot:item.Status="{ item }">
              {{ item.Status | display_value(exportRequestStatusList) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import configs from "@/configs";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import moment from "moment";
import { sendErrorNotice } from "@/commons/utils";
import {print_export_receipt} from '@/commons/hpod';
export default {
  components: {
    "mh-date-picker": MHDatePicker,
    "hpo-filter": Filtering,
  },
  data() {
    return {
      exportDate: null,
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: {...configs.PAGINATION},
      items_per_page: {...configs.ITEMS_PER_PAGE},
      packageStatus: configs.PACKAGE_STATUS,
      product_status: configs.PRODUCT_STATUS,
      bill_status: configs.BILL_STATUS,
      bill_status_list: configs.BILL_STATUS_LIST,
      exportRequestStatusList: configs.EXPORT_REQUEST_STATUS_LIST,
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã bao",
          value: "BigPackageCode",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.PACKAGE_STATUS
        },
        {
          text: "S.Kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "KG",
          value: "Weight",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "M3",
          value: "Volume",
          align: "end",
          decimal: 1,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "P.Ship (¥)",
          value: "FeeShip",
          align: "end",
          decimal: 2,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      detail_header: [
        {
          text: "Mã KH",
          value: "UserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên đối tác",
          value: "PartnerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên hàng",
          value: "ProductNameCN",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã vào kho",
          value: "Code",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã vận đơn",
          value: "SuffixBill",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Chi tệ",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tách thuế",
          value: "IsSplitTax",
          align: "center",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thuế nhập khẩu",
          value: "ImportTaxAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Thuế VAT",
          value: "VatTaxAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí dịch vụ",
          value: "ServiceFeeAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Phí ship",
          value: "FeeShipVND",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tổng tiền",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiết khấu",
          value: "DiscountAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Thành tiền",
          value: "LineAmount",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ghi chú",
          value: "Note",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "",
          value: "",
          align: "center",
          width: "80px",
        },
      ],
      filterConditions: [],
      quickFilterConditions: [],
      dialogItem: false,
      popup_header: [
        {
          text: "Mã KH",
          value: "UserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên đối tác",
          value: "PartnerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tên hàng",
          value: "ProductNameCN",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã vào kho",
          value: "Code",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã vận đơn",
          value: "SuffixBill",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Chi tệ",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tách thuế",
          value: "IsSplitTax",
          align: "center",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        }
      ],
      popupViewName: "popup_detail",
      selectedDetail: [],
      dialogRequest: false,
      selectedRequestRows: [],
      selectedRequestIds: [],
      requestHeaders: [
        {
          text: "Mã yêu cầu",
          value: "RequestCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã vận đơn",
          value: "SuffixBills",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Loại hàng",
          value: "GoodsTypes",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Số dòng",
          value: "TotalProduct",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "TotalPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.EXPORT_REQUEST_STATUS_LIST,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      customers: state => state.customer.master.data,
      currentItem: state => state.bill.selected,
      details: state => state.product.billList.data,
      total_details: state => state.product.billList.total,
      loading: state => state.bill.loading,
      popup_items: state => state.product.all.data,
      availableRequests: state => state.exportRequest.availableRequests.data || [],
    }),
    itemId() {
      return Number(this.$route.params.Pid);
    },
    computedCreatedDateFormatted () {
      return moment(this.currentItem.CreatedDate).format(configs.DATE_FORMAT);
    },
    computedPaymentDateFormatted () {
      return this.currentItem.PaymentDate ? moment(this.currentItem.PaymentDate).format(configs.DATE_FORMAT) : '';
    },
    roleEditable() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerSupport;
    },
    roleCustomer() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
    },
    isBillContentLocked() {
      return Number(this.currentItem.Status || this.bill_status.chua_xuat) !== this.bill_status.chua_xuat;
    },
    canEditBillStatus() {
      return this.roleEditable && Number(this.currentItem.Status || this.bill_status.chua_xuat) !== this.bill_status.da_thanh_toan;
    },
    canEditBillContent() {
      return this.roleEditable && !this.isBillContentLocked;
    },
    billStatusOptions() {
      if (Number(this.currentItem.Status || this.bill_status.chua_xuat) === this.bill_status.da_thanh_toan) {
        return this.bill_status_list;
      }
      return this.bill_status_list.filter(item => item.value !== this.bill_status.da_thanh_toan);
    },
    selectedRequestCodes() {
      return this.selectedRequestRows.map(item => item.RequestCode).join(", ");
    },
  },
  watch: {
    currentItem() {
      this.exportDate = this.currentItem.ExportDate
        ? moment.utc(this.currentItem.ExportDate).format('YYYY-MM-DD')
        : null;
    },
    roleEditable() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleSaveButton: !this.roleEditable});
    },
    details() {
      this.selectedDetail = [];
    }
  },
  methods: {
    getBillDetailActions(item) {
      return [
        { label: this.$t('actions.delete'), variant: 'danger-outline', hidden: !this.canEditBillContent, onClick: () => this.deleteDetail(item.ID) }
      ];
    },
    resetBillRequestSelection() {
      this.selectedRequestIds = [];
      this.selectedRequestRows = [];
    },
    syncSelectedRequestRows() {
      const selectedMap = new Set(this.selectedRequestIds.map(id => Number(id)));
      this.selectedRequestRows = this.availableRequests.filter(item => selectedMap.has(Number(item.ID)));
    },
    applyFilterDetail(filterConditions) {
      this.filterConditions = filterConditions;
      this.getAvailableProduct();
    },
    quickFilterDetail(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.getAvailableProduct();
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    onCustomerChanged() {
      let customer = _.find(this.customers, {ID: this.currentItem.UID});
      this.currentItem.CustomerName = customer ? customer.Username : '';
      this.currentItem.ReceiveName = customer ? customer.FullName : '';
      this.currentItem.ReceivePhone = customer ? customer.PhoneNumber : '';
      this.currentItem.ReceiveAddress = customer ? customer.Address : '';
      if (!this.itemId) {
        this.resetBillRequestSelection();
      }
    },
    async getAvailableRequests() {
      if (!this.currentItem.UID) {
        return [];
      }
      const params = {
        UID: this.currentItem.UID,
        pagination: {
          page: 1,
          itemsPerPage: 1000,
          sortBy: ["ID"],
          sortDesc: [true],
        },
      };
      if (this.currentItem.ID) {
        params.BillID = this.currentItem.ID;
      }
      const ret = await this.$store.dispatch("exportRequest/getAvailableRequests", params);
      return ret && ret.data ? ret.data : ret;
    },
    async loadLinkedRequests() {
      if (!this.currentItem.UID) {
        this.resetBillRequestSelection();
        return;
      }
      const rows = await this.getAvailableRequests();
      this.selectedRequestIds = (rows || [])
        .filter(item => Number(item.BillID || 0) === Number(this.currentItem.ID || 0))
        .map(item => Number(item.ID));
      this.syncSelectedRequestRows();
    },
    getAvailableProduct() {
      var param = {
        filter: [...this.filterConditions],
        quickFilter: this.quickFilterConditions
      };
      param.filter.push({
        column: "Status",
        value: [this.product_status.nhap_kho_vn, this.product_status.xuat_thieu],
        condition: "in",
      });
      param.filter.push({
        column: "UID",
        value: this.currentItem.UID,
        condition: "equal",
      });
      param.filter.push({
        column: "UID",
        value: 0,
        condition: "does_not_equal",
      });
      param.action = "ton-kho-vn";
      this.$store.dispatch("product/getList", param);
    },
    addDetail() {
      this.dialogItem = true;
      this.getAvailableProduct();
    },
    async openRequestDialog() {
      if (!this.currentItem.UID) {
        sendErrorNotice("Vui lòng chọn khách hàng trước khi chọn yêu cầu xuất kho.");
        return;
      }
      await this.getAvailableRequests();
      this.syncSelectedRequestRows();
      this.dialogRequest = true;
    },
    deleteDetail(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    onSelectDetail() {
      if(this.selectedDetail.length > 0) {
        let submitList = [];
        let payload = {};
        if(!this.itemId) {
          payload = {...this.currentItem,}
        }
        for (const item of this.selectedDetail) {
          submitList.push(item.ID);
        }
        payload.Products = submitList;
        this.$store.dispatch("bill/setDetail", {
          data: payload,
          id: this.currentItem.ID,
          ignore_compare: true
        }).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          } else if (!this.currentItem.ID) {
            this.$router.push({
              name: "BillDetail",
              params: { Pid: ret.ID, title: `Chi tiết hóa đơn` },
            });
            this.getDetail();
          }
        });
        this.selectedDetail = [];
        this.dialogItem = false;
      }
    },
    async onSelectRequests() {
      const requestIds = this.selectedRequestRows.map(item => Number(item.ID)).filter(id => id > 0);
      if (requestIds.length === 0) {
        sendErrorNotice("Vui lòng chọn ít nhất 1 yêu cầu xuất kho.");
        return;
      }

      const requestDetails = await Promise.all(
        requestIds.map(id => this.$store.dispatch("exportRequest/getDetail", id))
      );
      const productIds = _.uniq(
        requestDetails.reduce((result, item) => {
          const details = item && item.Details ? item.Details : [];
          details.forEach(detail => {
            const productId = Number(detail.ProductID || detail.ID || 0);
            if (productId > 0) {
              result.push(productId);
            }
          });
          return result;
        }, [])
      );

      if (productIds.length === 0) {
        sendErrorNotice("Các yêu cầu đã chọn chưa có hàng để nạp vào phiếu xuất.");
        return;
      }

      const existingProductIds = new Set((this.details || []).map(item => Number(item.ID)));
      const newProductIds = productIds.filter(id => !existingProductIds.has(id));
      const payload = {
        ...this.currentItem,
        RequestIDs: requestIds,
      };

      if (!this.currentItem.ID || newProductIds.length > 0) {
        payload.Products = this.currentItem.ID ? newProductIds : productIds;
      }

      const ret = await this.$store.dispatch("bill/setDetail", {
        data: payload,
        id: this.currentItem.ID,
        ignore_compare: true,
      });
      const savedItem = ret && ret.data ? ret.data : ret;
      if (_.isEmpty(savedItem)) {
        sendErrorNotice("Lỗi, không load được dữ liệu.");
        return;
      }

      this.selectedRequestIds = requestIds;
      this.dialogRequest = false;
      if (!this.currentItem.ID) {
        this.$router.push({
          name: "BillDetail",
          params: { Pid: savedItem.ID, title: "Chi tiết hóa đơn" },
        });
      }
      await this.getDetail();
    },
    saveData() {
      this.$store.dispatch("bill/setDetail", {
        data: {
          ...this.currentItem,
          RequestIDs: this.selectedRequestIds,
          ExportDate: Number(this.currentItem.Status || this.bill_status.chua_xuat) === this.bill_status.chua_xuat
            ? null
            : (this.exportDate ? moment.utc(this.exportDate).format(configs.SQL_DATE_FORMAT) : moment().format(configs.SQL_DATE_FORMAT)),
        },
        id: this.currentItem.ID,
        ignore_compare: true
      });
    },
    saveProduct(item) {
      this.$store.dispatch("product/setDetail", {
        'data': item,
        'id': item.ID
    });
    },
    saveBillProduct(item) {
      this.$store.dispatch("billProduct/setDetail", {
        'data': {
          ...item
        },
        'id': 99999999
      });
    },
    deliverItem() {
      this.$store.dispatch("bill/setDetail", {
        data: { Status: this.bill_status.da_xuat },
        id: this.currentItem.ID,
        ignore_compare: true
      });
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "FullName", "PhoneNumber", "Address"]
      });
    },
    getDetail() {
      this.getCustomerList();
      if (!this.itemId) {
        this.$store.commit("bill/setDetail", { ID: 0, UID: 0, Status: this.bill_status.chua_xuat, ShipmentWeightPrice: 0, ShipmentVolumePrice: 0 });
        this.resetBillRequestSelection();
      } else {
        this.$store.dispatch("bill/getDetail", this.itemId).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          } else {
            this.loadLinkedRequests();
          }
        });
        this.$store.dispatch("product/getBillList", this.itemId);
      }
    },
    printItem() {
      print_export_receipt(this.currentItem, this.details);
    }
  },
  mounted() {
    this.getDetail();
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleSaveButton: !this.roleEditable});
    this.$root.$on("REQUEST_CREATE_DATA", this.printItem);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("product/setDetail", {
        'data': {'BillID': 0},
        'id': id
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA");
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
